import PostFileClickListing from "../post-file-click/views/pages/postFileClickListing.vue";
export const postFileClickRouters = [
	{
		path: "/post-file-click",
		name: "PostFileClickListing",
		component: PostFileClickListing
	}
];
